import { hourToPeriod } from "@/helpers/time";
import moment from "moment-timezone";

export const REPORT_MENU = "reports";
export const TOOLS_MENU = "tools";

export const reportOptions = {
  gateway_currency_source: {
    ignored: true,
    headers: [
      "bank_name",
      "charge_currency",
      "offline_donation_source",
      "threshold",
      "count_donations",
      "sum_real",
      "average_real",
      "sum_total",
      "average_total",
    ],
  },
  gateway_currency_rec_duration_installments: {
    ignored: true,
    headers: [
      "bank_name",
      "charge_currency",
      "installments",
      "count_donations",
      "sum_real",
      "average_real",
      "sum_total",
      "average_total",
    ],
  },
  referrer_id_team_name: {
    ignored: true,
    headers: [
      "referrer_id",
      "team_name",
      "count_donations",
      "sum_real",
      "average_real",
      "sum_total",
      "average_total",
    ],
  },
  team_name_referrer_id: {
    ignored: true,
    headers: [
      "team_name",
      "referrer_id",
      "count_donations",
      "sum_real",
      "average_real",
      "sum_total",
      "average_total",
    ],
  },
  team_name_bank_name_referrer_id: {
    ignored: true,
    headers: [
      "team_name",
      "bank_name",
      "referrer_id",
      "count_donations",
      "sum_real",
      "average_real",
      "sum_total",
      "average_total",
    ],
  },
  pending_failed_donation_followups: {
    menu: REPORT_MENU,
    downloadBtnNextToSendToEmail: true,
    label: "Follow up report",
    headers: [
      "donation_id",
      "billing_name",
      "display_name",
      "gateway",
      "amount_charged",
      "amount_effective",
      "email",
      "phone",
      "team",
      "parent_team",
      "grandparent_team",
      "g2parent_team",
      "date",
      "status",
    ],
    headersTkFallbacks: [
      "Donatoin ID",
      "Donor Billing Name",
      "Display Name",
      "Gateway",
      "Amount charged",
      "Effective Amount",
      "Email",
      "Phone",
      "Team",
      "Parent team",
      "Grandparent team",
      "Gx2 Parent team",
      "Donation date",
      "Status",
    ],
  },
  recurring_estimates_projection: {
    menu: TOOLS_MENU,
    label: "Recurring estimates projection",
    headers: [
      "display_month",
      "total_charged",
      "recurring_donors",
      "gateway_to_total_charged",
      "gateway_to_recurring_donors",
    ],
    headersTkFallbacks: [
      "Display month",
      "Total charged",
      "Recurring donors",
      "Gateway To Total Charged",
      "Gateway To Recurring donors",
    ],
    hidePagination: true,
    hideDateFillter: false,
    classes: {
      gateway_to_total_charged: "wp-pre-line",
      gateway_to_recurring_donors: "wp-pre-line",
    },
    formatters: {
      total_charged(value, key, item) {
        const intlValue = new Intl.NumberFormat("en-US").format(value);
        return `${intlValue} ${item.attributes.campaign_currency}`;
      },
      gateway_to_total_charged(value, key, item) {
        return Object.entries(value || {})
          .map(([k, v]) => {
            const intlValue = new Intl.NumberFormat("en-US").format(v);
            return `${k}: ${intlValue} ${item.attributes.campaign_currency}`;
          })
          .join("\n");
      },
      gateway_to_recurring_donors(value) {
        return Object.entries(value || {})
          .map(([k, v]) => {
            return `${k}: ${v}`;
          })
          .join("\n");
      },
    },
  },
  pickup_report: {
    menu: REPORT_MENU,
    label: "Pickup report",
    headers: [
      "ID",
      "CreatedAt",
      "UpdatedAt",
      "DeletedAt",
      "campaign_id",
      "name",
      "number",
      "address",
      "telephone",
      "amount",
      "team_page",
      "comment",
      "driver",
      "envelope",
      "dispatched",
      "arrived",
      "offline",
      "cash_vouchers",
      "admin",
    ],
    headersTkFallbacks: [
      "Id",
      "Created At",
      "Updated At",
      "Deleted At",
      "Campaign Id",
      "Name",
      "Number",
      "Address",
      "Telephone",
      "Amount",
      "Team Page",
      "Comment",
      "Driver",
      "Envelope",
      "Dispatched",
      "Arrived",
      "Offline",
      "Cash Vouchers",
      "Admin",
    ],
    hidePagination: true,
    hideDateFillter: true,
    sendToEmailBtnOnly: false,
    fetchFunction: ({ store, cId, date, page, perPage }) => {
      const params = {
        date_from: date.from,
        date_to: date.to,
        page,
        per_page: perPage,
      };

      store.dispatch("getReportsPickupReport", { cId, params });
    },
  },
  report_sms: {
    menu: REPORT_MENU,
    label: "SMS report",
    headers: [],
    headersTkFallbacks: [],
    hidePagination: true,
    hideDateFillter: true,
    downloadBtnOnly: true,
  },
  report_email: {
    menu: REPORT_MENU,
    label: "Email report",
    headers: [],
    headersTkFallbacks: [],
    hidePagination: true,
    hideDateFillter: true,
    downloadBtnOnly: true,
  },
  utm: {
    menu: REPORT_MENU,
    label: "UTM report",
    headers: [
      "utm_shortlink",
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
      "count",
      "amount",
      "amout_real",
      "average",
      "average_real",
    ],
    headersTkFallbacks: [
      "UTMShortLink",
      "UTMSource",
      "UTMMedium",
      "UTMCampaign",
      "UTMTerm",
      "UTMContent",
      "Count",
      "Amount",
      "AmoutReal",
      "Average",
      "AverageReal",
    ],
    hidePagination: true,
    hideDateFillter: false,
    sendToEmailBtnOnly: false,
  },
  donation_failed: {
    menu: REPORT_MENU,
    label: "Donation failed report",
    headers: [
      { key: "id", sortable: true },
      "created_at",
      "campaign_id",
      "name",
      "display_name",
      "amount",
      "email",
      "phone",
      "team",
      "parent_team",
      "device_id",
      "reason",
      "error",
    ],
    getSortBy: (sortBy, sortDesc) => {
      let map = {
        id: "id",
      };
      return `${map[sortBy] || sortBy}_${sortDesc ? "desc" : "asc"}`;
    },
    defaultSortBy: "id_desc",
    headerKey: (h) => h?.key || h,
    headersTkFallbacks: [
      "ID",
      "CreatedAt",
      "Campaign ID",
      "Name",
      "Display name",
      "Amount",
      "Email",
      "Phone",
      "Team",
      "Parent team",
      "Device ID",
      "Reason",
      "Error",
    ],
    hideDateFillter: false,
    hideSendToEmail: true,
    downloadBtnNextToSendToEmail: true,
    fetchFunction: ({ store, cId, page, perPage, sortBy, excludeZereoAmounts, date }) => {
      const params = {
        page,
        per_page: perPage,
        sort_by: sortBy,
        exclude_zereo_amounts: Number(excludeZereoAmounts),
        date_from: date.from,
        date_to: date.to,
      };

      store.dispatch("getReportsDonationFailed", { cId, params });
    },
    formatters: {
      name(value, key, item) {
        return `${item.billing_first_name} ${item.billing_last_name}`;
      },
      created_at(date) {
        return moment(date).format("MMMM D, YYYY h:mm a");
      },
      amount(value, key, item) {
        return `${item.amount} ${item.currency}`;
      },
      team(value, key, item) {
        if (!item.team) {
          return "";
        }

        return `${item.team.id}: ${item.team.name}`;
      },
      parent_team(value, key, item) {
        if (!item.parent_team) {
          return "";
        }

        return `${item.parent_team.id}: ${item.parent_team.name}`;
      },
    },
  },
  foundation_report: {
    menu: REPORT_MENU,
    label: "Foundation report",
    headers: [],
    headersTkFallbacks: [],
    hidePagination: true,
    hideDateFillter: true,
    downloadBtnOnly: true,
  },
  past_campaign_donors_outreach: {
    menu: TOOLS_MENU,
    label: "Past campaigns donors outreach",
    headers: [
      "$selected",
      "id",
      "billing_name",
      "display_name",
      "charge_amount",
      "effective_amount",
      "recurring_interval",
      "email",
      "phone",
      "teams",
      "date",
      "actions",
    ],
    headerKey: (h) => h?.key || h,
    getSortBy: (sortBy, sortDesc) => {
      let map = {
        billing_name: "fname",
        charge_amount: "real_payment",
        effective_amount: "total",
        date: "date_added",
      };
      return `${map[sortBy] || sortBy}_${sortDesc ? "desc" : "asc"}`;
    },
    headersTkFallbacks: [
      "Selected",
      "Donation ID",
      "Donor Billing Name",
      "Display Name",
      "Amount charged",
      "Effective Amount",
      "Recurring interval",
      "Email",
      "Phone",
      "Teams",
      "Donation date",
      "Actions",
    ],
    classes: {
      teams: "wp-pre-line",
    },
    formatters: {
      charge_amount(value, key, item) {
        return `${value} ${item.currency_code}`;
      },
      effective_amount(value, key, item) {
        return `${value} ${item.currency_code}`;
      },
      date(v) {
        const d = new Date(v);
        return d.toLocaleString("en-US");
      },
      teams(_value, _key, item) {
        const teams = item.team_list || [];
        const formatTeam = (t) => (t.id ? `${t.id}: ${t.name}` : t.name);

        if (teams.length <= 10) {
          return teams.map(formatTeam).join("\n");
        }

        const displayedTeams = teams.slice(0, 10).map(formatTeam).join("\n");
        const remainingCount = teams.length - 10;

        return `${displayedTeams}\n${remainingCount} more`;
      },
      recurring_interval(_value, _key, item) {
        if (item.recurring_plan) {
          return `${item.recurring_plan.duration} ${item.recurring_plan.period}`;
        }
        return "One-time";
      },
    },
    hidePagination: false,
    hideDateFillter: true,
    hideSendToEmail: true,
    downloadBtnNextToSendToEmail: true,
    rowSelection: true,
  },
  stripe_recurring_plan_summary: {
    menu: REPORT_MENU,
    label: "Stripe Recurring Plan Summary",
    headers: [
      {
        key: "campaign_id",
        sortable: false,
      },
      {
        key: "recurring",
        sortable: false,
      },
      {
        key: "donor_name",
        sortable: false,
      },
      {
        key: "email",
        sortable: false,
      },
      {
        key: "stripe_account",
        sortable: false,
      },
      {
        key: "org_legal_name",
        sortable: false,
      },
      {
        key: "duration",
        sortable: true,
      },
      {
        key: "charges",
        sortable: false,
      },
      {
        key: "charge",
        sortable: false,
      },
      {
        key: "currency",
        sortable: false,
      },
      {
        key: "total_charged",
        sortable: false,
      },
      {
        key: "remaining",
        sortable: false,
      },
      {
        key: "estimated_total",
        sortable: false,
      },
      {
        key: "in_campaign_currency",
        sortable: false,
      },
      {
        key: "campaign_currency",
        sortable: false,
      },
      {
        key: "plan_status",
        sortable: false,
      },
      {
        key: "last_charge",
        sortable: false,
      },
      {
        key: "bank_name",
        sortable: false,
      },
      {
        key: "reason_canceled",
        sortable: false,
      },
    ],
    headerKey: (h) => h?.key || h,
    getSortBy: (sortBy, sortDesc) => {
      let map = {
        billing_name: "fname",
        charge_amount: "real_payment",
        effective_amount: "total",
        date: "date_added",
      };
      return `${map[sortBy] || sortBy}_${sortDesc ? "desc" : "asc"}`;
    },
    headersTkFallbacks: [
      "CampaignId",
      "Recurring",
      "DonorName",
      "Email",
      "StripeAccount",
      "OrgLegalName",
      "Duration",
      "Charges",
      "Charge",
      "Currency",
      "TotalCharged",
      "Remaining",
      "EstimatedTotal",
      "InCampaignCurrency",
      "CampaignCurrency",
      "PlanStatus",
      "LastCharge",
      "BankName",
      "ReasonCanceled",
    ],
    hidePagination: false,
    hideDateFillter: true,
    hideSendToEmail: true,
    downloadBtnNextToSendToEmail: true,
  },
  stripe_report: {
    menu: REPORT_MENU,
    label: "Stripe report",
    headers: [],
    headersTkFallbacks: [],
    hidePagination: true,
    hideDateFillter: false,
    hideSendToEmail: true,
    sendToEmailBtnOnly: false,
    downloadBtnOnly: false,
    downloadBtnNextToSendToEmail: false,
    showOnlyOneBtn: false,
    refreshButtonTKey: ["reports.generate_report_btn", "Generate report"],
    // Add throttling logic
    _lastFetchTime: null,
    fetchFunction: (args) => {
      const now = Date.now();
      // 'this' refers to the parent object (stripe_report) if accessed as reportOptions.stripe_report.fetchFunction.call(reportOptions.stripe_report, ...)
      if (
        reportOptions.stripe_report._lastFetchTime &&
        now - reportOptions.stripe_report._lastFetchTime < 10000
      ) {
        args.store.commit("setErrors", ["Please wait a few seconds before generating again"]);
        return;
      }
      reportOptions.stripe_report._lastFetchTime = now;
      args.setManualDisable(true);
      const data = {
        from: args.date.from ? moment(args.date.from).format("YYYY-MM-DD") : null,
        to: args.date.to ? moment(args.date.to).format("YYYY-MM-DD") : null,
        to_emails: args.toEmails,
        acct_list: args.acctList,
      };
      args.store
        .dispatch("getReportsStripe", { cId: args.cId, params: {}, data })
        .catch((error) => {
          args.store.commit("setErrors", error?.response?.data?.errors || ["Failed to fetch"]);
        })
        .finally(() => {
          args.setManualDisable(false);
        });
    },
  },
  not_donated: {
    menu: TOOLS_MENU,
    label: "Organization preuploaded donors",
    headers: [],
    headersTkFallbacks: [],
    hidePagination: true,
    hideDateFillter: true,
    hideSendToEmail: true,
    sendToEmailBtnOnly: false,
    downloadBtnOnly: true,
  },
  team_management: {
    menu: TOOLS_MENU,
    label: "Team Management",
    headers: [
      "g2parent_team",
      "grandparent_team",
      "parent_team",
      "team",
      "goal",
      "raised",
      "direct_raised",
      "indirect_raised",
      "direct_donors",
      "indirect_donors",
      "balance",
      "percentage_raised",
      "donors",
      "email",
      "phone",
    ],
    headersTkFallbacks: [
      "Gx2 Parent Team",
      "Grandparent Team",
      "Parent Team",
      "Team",
      "Goal",
      "Raised",
      "Direct Raised",
      "Indirect Raised",
      "Direct Donors",
      "Indirect Donors",
      "Balance",
      "Percentage Raised",
      "Donors",
      "Email",
      "Phone",
    ],
    formatters: {
      g2parent_team(value, key, item) {
        const attrs = item.attributes || {};
        if (!attrs.g2parent_id) {
          return "";
        }
        return `${attrs.g2parent_id}: ${attrs.g2parent_team_name}`;
      },
      grandparent_team(value, key, item) {
        const attrs = item.attributes || {};
        if (!attrs.grandparent_id) {
          return "";
        }
        return `${attrs.grandparent_id}: ${attrs.grandparent_team_name}`;
      },
      parent_team(value, key, item) {
        const attrs = item.attributes || {};
        if (!attrs.parent_id) {
          return "";
        }
        return `${attrs.parent_id}: ${attrs.parent_team_name}`;
      },
      team(value, key, item) {
        const attrs = item.attributes || {};
        if (!attrs.team_id) {
          return "";
        }
        return `${attrs.team_id}: ${attrs.team_name}`;
      },
    },
    hideDateFillter: true,
    hideSendToEmail: true,
    downloadBtnNextToSendToEmail: true,
  },
  team_leader_contacts: {
    menu: TOOLS_MENU,
    label: "Team Leader Contacts",
    headers: [
      "id",
      "created_at",
      "name",
      "email",
      "phone",
      "address1",
      "team_id",
      "campaign_id",
      "status",
      "note",
      "expected_donation_amount",
      "relationship",
    ],
    headersTkFallbacks: [
      "ID",
      "Created At",
      "Name",
      "Email",
      "Phone",
      "Address 1",
      "Team ID",
      "Campaign ID",
      "Status",
      "Note",
      "Expected Donation",
      "Relationship",
    ],
    headerKey: (h) => h?.key || h,
    formatters: {
      created_at(date) {
        return moment(date).format("MM/D/YYYY h:mm a");
      },
      name(value, key, item) {
        return `${item.first_name} ${item.last_name}`;
      },
      expected_donation_amount(value, key, item) {
        return `${value} ${item.expected_donation_currency}`;
      },
    },
    hideDateFillter: true,
    hideSendToEmail: true,
    downloadBtnNextToSendToEmail: true,
    fetchFunction: ({ store, cId, page, perPage }) => {
      const params = {
        page,
        per_page: perPage,
      };

      store.dispatch("getTeamLeaderContactsReportList", { cId, params });
    },
  },
  organization_payments_for_period: {
    menu: REPORT_MENU,
    label: "Report Aggregated Payments For Period",
    headers: [],
    headersTkFallbacks: [],
    hidePagination: true,
    hideDateFillter: true,
    hideCampaignFilter: true,
    sendToEmailBtnOnly: true,
  },
  campaign_by_hour_compare_report: {
    menu: TOOLS_MENU,
    label: "Campaign By Hour Compare Report",
    headers: [
      "time",
      "online_donations_campaign1",
      "offline_donations_campaign1",
      "online_donors_campaign1",
      "offline_donors_campaign1",
      "online_donations_campaign2",
      "offline_donations_campaign2",
      "online_donors_campaign2",
      "offline_donors_campaign2",
    ],
    headersTkFallbacks: [
      "Period",
      "Online donations campaign1",
      "Offline donations campaign1",
      "Online donors campaign1",
      "Offline donors campaign1",
      "Online donations campaign2",
      "Offline donations campaign2",
      "Online donors campaign2",
      "Offline donors campaign2",
    ],
    formatters: {
      time(value) {
        return hourToPeriod(value);
      },
    },
    hidePagination: true,
    hideDateFillter: true,
    sendToEmailBtnOnly: false,
    hideSendToEmail: true,
    enableChart: true,
  },
  two_campaigns_donation_amount: {
    menu: TOOLS_MENU,
    label: "Campaign Donation Amount Range Stats",
    headers: [
      "donation_range",
      "total_amount_campaign1",
      "total_amount_campaign2",
      "countof_donors_campaign1",
      "countof_donors_campaign2",
      "average_amount_campaign1",
      "average_amount_campaign2",
    ],
    headersTkFallbacks: [
      "Donation Range",
      "Total Amount Campaign 1",
      "Total Amount Campaign 2",
      "Count of Donors Campaign 1",
      "Count of Donors Campaign 2",
      "Average Amount Campaign 1",
      "Average Amount Campaign 2",
    ],
    hidePagination: true,
    hideDateFillter: true,
    sendToEmailBtnOnly: false,
    hideSendToEmail: true,
  },
  team_quick_signup_links: {
    label: "Team Quick Signup Links",
    headers: ["team_id", "team_name", "link"],
    headersTkFallbacks: ["Team ID", "Team Name", "Link"],
    hideDateFillter: true,
    hideSendToEmail: true,
    downloadBtnNextToSendToEmail: true,
  },
  integration_logs: {
    menu: TOOLS_MENU,
    label: "Integration export list",
    headers: [
      "id",
      "source_entity_id",
      "service",
      "destination_entity_type",
      "destination_entity_id",
      "successful",
    ],
    headerKey: (h) => h?.key || h,
    headersTkFallbacks: [
      "ID",
      "Donation ID",
      "Service",
      "Destination entity type",
      "Destination entity id",
      "Successful",
    ],
    hideSendToEmail: true,
    downloadBtnNextToSendToEmail: true,
  },
  /* post_campaign_report: {
    label: "Post Campaign Report",
    headers: [],
    headersTkFallbacks: [],
    hidePagination: true,
    hideDateFillter: true,
    hideSendToEmail: true,
    downloadBtnOnly: false,
    downloadBtnNextToSendToEmail: false,
    showOnlyOneBtn: false,
    refreshButtonTKey: ["reports.generate_report_btn", "Generate report"],
    fetchFunction: async ({ cId, setReloadData, setManualDisable, store }) => {
      setManualDisable(true);
      setReloadData(null);

      const authCode = await store
        .dispatch("getLookerStudioToken", {
          reportName: "post_campaign_report",
          params: { campaign_id: cId },
        })
        .catch((error) => {
          store.commit("setErrors", error?.response?.data?.errors || ["Failed to fetch"]);
          setManualDisable(false);
        });
      if (!authCode) {
        return;
      }

      const lookerUrl = new URL(
        `https://lookerstudio.google.com/embed/reporting/:lookerReportId/page/:lookerReportPageId`
      );
      const lookerReportId = "728a1c5f-a399-4978-8248-1de1dffa5d87";
      const lookerReportPageId = "C4eZD";

      const params = {
        "ds0.api_host": dashboardApiHost,
        "ds0.auth_code": authCode,
      };

      const searchParams = new URLSearchParams({
        params: JSON.stringify(params),
      });

      lookerUrl.search = searchParams.toString();
      let lookerStringUrl = lookerUrl.toString();
      lookerStringUrl = lookerStringUrl
        .replace(":lookerReportId", lookerReportId)
        .replace(":lookerReportPageId", lookerReportPageId);

      setManualDisable(false);
      return setReloadData(lookerStringUrl);
    },
  }, */
  custom: {
    menu: REPORT_MENU,
    label: "Custom",
    headers: [],
    headersTkFallbacks: [],
    hidePagination: true,
    hideDateFillter: true,
    hideCampaignFilter: true,
    hideSendToEmail: true,
  },
};

export const reportNames = Object.keys(reportOptions);
